import httpService from '@/core/services/http.service.js';
import legalEntityMapper from '@/core/services/helpers/legalEntityMapper.js';

// action types
export const GET_LEGAL_ENTITIES = 'getLegalEntities';

// mutations types
export const SET_LEGAL_ENTITIES = 'setLegalEntities';
export const SET_LEGAL_META = 'setLegalMeta';

const state = {
  legalEntities: [],
  meta: {},
};

const getters = {
  allLegalEntities: (state) => state.legalEntities,
  legalEntitiesMeta: (state) => state.meta,
};

const actions = {
  [GET_LEGAL_ENTITIES](context, { pageNumber = 1, perPage = 10, search = '' }) {
    httpService
      .get(`/api/b2b/legal-entities?page=${pageNumber}&per_page=${perPage}&search=${search}`)
      .then((response) => {
        context.commit(SET_LEGAL_ENTITIES, response.data.data);
        context.commit(SET_LEGAL_META, response.data.meta);
      });
  },
};

const mutations = {
  [SET_LEGAL_ENTITIES](state, legalEntities) {
    state.legalEntities = legalEntityMapper.mapLegalEntities(legalEntities);
  },
  [SET_LEGAL_META](state, meta) {
    state.meta = meta;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
